module.exports = __webpack_public_path__ + "img/Menu-03.970288dd.png";